import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import { clearBusinessEquipmentRiskState, fetchBusinessPolicyEquipmentListAsync } from "../../../../../../redux/businessPolicy/businessPolicyEquipment/businessPolicyEquipmentActions";

export const useBusinessPolicyEquipment = (customerPolicyId?: number) => {
  const dispatch = useDispatchWrapper();
  const EquipmentList = useSelector(
	(storeState: IStoreState) => storeState.business.equipment.data
  );

  const equipmentDropdown = React.useMemo(() => {
	return EquipmentList.map((item) => {
	  return {
		label:
		  item.incremental_number,
		value: item.incremental_number || "",
	  };
	});
  }, [EquipmentList]);

  const refreshData = () => {
	if (customerPolicyId) {
		dispatch(fetchBusinessPolicyEquipmentListAsync(Number(customerPolicyId), "ACTIVE"));
	  }
  }

  React.useEffect(() => {
	if (customerPolicyId) {
	  dispatch(fetchBusinessPolicyEquipmentListAsync(Number(customerPolicyId), "ACTIVE"));
	}
	return () => {
	  dispatch(clearBusinessEquipmentRiskState());
	};
  }, []);

  return { equipmentDropdown, refreshData };
};
